import React, { Component } from "react";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn } from "react-icons/fa";
import { FiX , FiMenu} from "react-icons/fi";
import Scrollspy from 'react-scrollspy'
import { Link } from "react-router-dom";


const SocialShare = [
    // {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/powerhouse-africa-a83438208'},
    // {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]
class HeaderThree extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CloseMenuTrigger = this.CLoseMenuTrigger.bind(this);
        this.stickyHeader = this.stickyHeader.bind(this);

       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded');
        })
        
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open')
    }

    stickyHeader () {}

    render(){

        window.addEventListener('scroll', function() {
            var value = window.scrollY;
            if (value > 100) {
                document.querySelector('.header--fixed').classList.add('sticky')
            }else{
                document.querySelector('.header--fixed').classList.remove('sticky')
            }
        });

        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color='default-color' } = this.props;
        let logoUrl;
        console.log(logo);
        
        logoUrl = <img src="/assets/images/logo/logo.png" alt="logo" />;
        
        return(
            <header className={`header-area header-style-two header--fixed ${color}`}>
                <section className="header-wrapper">
                    <section className="header-left d-flex align-items-center">
                        <section className="logo">
                            <a href={this.props.homeLink}>
                                {logoUrl}
                            </a>
                        </section>
                        <nav className="mainmenunav d-lg-block ml--50">
                            <Scrollspy className="mainmenu" items={['home','about','service','portfolio','blog','products','team','contact']} currentClassName="is-current" offset={-200}>
                                <li><a href="#home">Home</a></li>
                                <li><Link to= "/about-us">About Us</Link></li>
                                <li><a href="#service">Services</a></li>
                                <li><a href="#portfolio">Portfolio</a></li>
                                <li><a href="#blog">News</a></li>
                                <li><Link to={{ pathname : "/products"}}>Products</Link></li>                        
                                <li><a href="#contact">Contact</a></li>
                            </Scrollspy>
                        </nav>
                    </section>
                    <section className="header-right">
                        <section className="social-share-inner">
                            <ul className="social-share social-style--2 color-black d-flex justify-content-start liststyle">
                                {SocialShare.map((val , i) => (
                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                ))}
                            </ul>
                        </section>
                        <section className="header-btn">
                            <a className="rn-btn" target="_" href="https://api.powerhouse-africa.com/admin/">
                                <span>Login</span>
                            </a>
                        </section>
                        {/* Start Humberger Menu  */}
                        <section className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </section>
                        {/* End Humberger Menu  */}
                        <section className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </section>
                    </section>
                </section>
            </header>
        )
    }
}
export default HeaderThree;